<template>
  <div class="relative inline-block">
    <!-- Profile Button -->
    <button
      @click="toggleMenu"
      class="flex items-center gap-2 p-3 h-10 border-gray-200 rounded-lg shadow-sm transition-colors"
    >
      <div
        class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center"
      >
        <i class="fa-regular fa-user w-5 h-5 text-blue-600"></i>
      </div>
      <span class="text-lg font-semibold text-white">
        {{ userStore.userName }}
      </span>
      <i
        :class="`fa-solid fa-chevron-down w-4 h-4 text-white transition-transform ${
          isOpen ? 'rotate-180' : ''
        }`"
      />
    </button>

    <!-- Dropdown Menu -->
    <template v-if="isOpen">
      <div class="fixed inset-0 z-10" @click="isOpen = false" />

      <!-- Menu -->
      <div
        class="absolute top-full right-1 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-20"
      >
        <button
          v-for="(item, index) in menuItems"
          :key="index"
          @click="handleMenuClick(item)"
          class="group w-full flex items-center gap-3 px-4 py-3 text-left text-gray-700 hover:bg-gray-50 transition-colors first:rounded-t-lg last:rounded-b-lg"
        >
          <i :class="`fas ${item.icon} w-4 h-4 ${item.iconColorClass}`"></i>
          <span>{{ item.label }}</span>
        </button>
      </div>
    </template>

    <!-- 비밀번호 변경 팝업 -->
    <PopPasswordChange
      :is-open="isPasswordModalOpen"
      @close="isPasswordModalOpen = false"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/store/userStore";

import PopPasswordChange from "@/components/Popup/PopPasswordChange.vue";

const router = useRouter();
const userStore = useUserStore();

const isOpen = ref(false);
const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

const handleMenuClick = (item) => {
  item.onClick();
  isOpen.value = false;
};

const menuItems = [
  {
    icon: "fa-gear",
    label: "비밀번호 변경",
    iconColorClass: "text-gray-500 group-hover:text-blue-600",
    onClick: () => btnPasswordClick(),
  },
  {
    icon: "fa-sign-out-alt",
    label: "로그아웃",
    iconColorClass: "text-gray-500 group-hover:text-blue-600",
    onClick: () => btnLogoutClick(),
  },
];

// 로그아웃 메뉴 클릭
const btnLogoutClick = () => {
  // console.log("btnLogoutClick");

  userStore.clearSession();

  router.push("/auth/login");
};

// 비밀번호 변경 메뉴 클릭
const isPasswordModalOpen = ref(false);

const btnPasswordClick = () => {
  isPasswordModalOpen.value = true;
};
</script>
